import { render, staticRenderFns } from "./dataSourceConnection.vue?vue&type=template&id=93486db0&scoped=true"
import script from "./dataSourceConnection.vue?vue&type=script&lang=js"
export * from "./dataSourceConnection.vue?vue&type=script&lang=js"
import style0 from "./dataSourceConnection.vue?vue&type=style&index=0&id=93486db0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93486db0",
  null
  
)

export default component.exports